// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrainingVideo__video__GTh74{display:flex;flex:2 1 auto;margin-top:1rem;max-width:634px;max-height:356px;width:100%;height:100%}
`, "",{"version":3,"sources":["webpack://./src/js/apps/processflow/components/fields/TrainingVideo/TrainingVideo.scss"],"names":[],"mappings":"AAEA,6BACI,YAAa,CACb,aAAc,CACd,eAAgB,CAChB,eAAgB,CAChB,gBAAiB,CACjB,UAAW,CACX,WAAY","sourcesContent":["@import \"shared/variables\";\n\n.video {\n    display: flex;\n    flex: 2 1 auto;\n    margin-top: 1rem;\n    max-width: 634px;\n    max-height: 356px;\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video": `TrainingVideo__video__GTh74`
};
export default ___CSS_LOADER_EXPORT___;
